export default __webpack_public_path__ + "static/media/blue_env.38dad525.svg";